<template lang="pug">
table.table.table-categ-question
  thead
    tr(style="text-align: left; font: Bold 15px/17px Helvetica; letter-spacing: 0px; color: #343A40; opacity: 1;")
      th(v-for='c in columns'
        :key='c.title') 
          span {{c.title}}
          span(v-if="c.key === 'name' && doSort")
            .fas.fa-sort-alpha-down(@click="filterItems(sort, 6)"
              :class="sort ? 'checked' : ''")
  tbody
    tr(v-if='this.inlineFilter === true' style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(width="32px")
      td
        input#name(@change="onnameChange($event)" placeholder="Tìm theo tên" 
        style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 5px;width:100%;")
      td
      td
      td
      td
      td
    tr(v-if='this.data.length === 0', style='white-space: nowrap;') Không có dữ liệu
    tr(v-else v-for='item in data' v-bind:id="'row' + item.id")
      td(v-for='c in columns')
        span(v-if='hasValue(item, c)' v-html='itemValue(item, c)')
        span.list-action.function-action(v-if='isAction(c)')
          small(@click="editItem(item)")
            img(:src="require('../../../assets/images/faces/ic_edit.svg')")
          small(@click="deleteItem(item)")
            img(:src="require('../../../assets/images/theory/delete-24px.svg')")  
</template>

<script>
import moment from 'moment'

export default {
  name: 'tbCateQuestion',
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    inlineFilter: {
      type: Boolean,
      default: false
    },
    doSort: {
      type: Boolean,
      default: false
    },
    lstFilter: Object
  },
  data() {
    return {
      dataFilter: {},
      sort: false
    }
  },
  methods: {
    editItem(item) {
      // console.log('Edit Item ' + item.id)
      this.$emit('onItemEdit', item)
    },
    deleteItem(item) {
      // console.log('Delete Item ', item)
      this.$emit('onItemDelete', item)
    },
    hasValue(item, col) {
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item[col.key]).format('DD/MM/YYYY - hh:mm')
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    isCustom(col) {
      if (col.type === 'custom') return true
      else return false
    },
    itemValue(item, column) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'date') {
          return this.fmDate(item, column)
        } else if (column.type === 'custom') {
          return value
        } else if (column.type === 'created_user' || column.type === 'updated_user') {
          return value.fullname
        }
      } else {
        if (typeof value === 'object') return value.name
        return value
      }
    },
    onnameChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbyname', event.target.value)
    },
    filterItems(id, type) {
      if (type === 6) {
        this.sort = !this.sort
        this.dataFilter.order_by = this.sort
      }
      this.$emit('onFilterBlue', this.dataFilter)
    }
  }
}

</script>
<style lang="scss">
.list-action {
  cursor: pointer;
  // &.function-action{text-align: center;}
  small{width: 16px; height: 16px; margin-right: 16px; display: inline-block;
    img{max-width: 100%; height: 16px;}
  }
}
.table-categ-question {
  margin-bottom: 0;
  thead {
    tr {
      th {
        padding: 10px 10px;
        text-align: left; 
        font: Bold 15px/18px Helvetica; 
        letter-spacing: 0px; 
        color: #343A40;
        opacity: 1;
        .fa-sort-alpha-down {margin-left: 10px; cursor: pointer;
          &.checked {
            color: #219AFF;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        text-align: left !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// tbCateQuestion.vue?43bfcc8d